var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReferenceObject = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.8024 12L12 1.80243L22.1976 12L12 22.1976L1.8024 12ZM12.5444 0.225533C12.2437 -0.0751441 11.7563 -0.075145 11.4556 0.225532L0.225508 11.4556C-0.0751688 11.7563 -0.0751696 12.2438 0.225508 12.5444L11.4556 23.7745C11.7563 24.0752 12.2437 24.0752 12.5444 23.7745L23.7745 12.5445C24.0752 12.2438 24.0752 11.7563 23.7745 11.4556L12.5444 0.225533ZM14.7803 7.71966C14.4874 7.42676 14.0126 7.42676 13.7197 7.71966C13.4268 8.01255 13.4268 8.48742 13.7197 8.78032L16.1893 11.25H6C5.58579 11.25 5.25 11.5858 5.25 12C5.25 12.4142 5.58579 12.75 6 12.75H16.1893L13.7197 15.2197C13.4268 15.5126 13.4268 15.9874 13.7197 16.2803C14.0126 16.5732 14.4874 16.5732 14.7803 16.2803L18.5303 12.5303C18.8232 12.2374 18.8232 11.7625 18.5303 11.4697L14.7803 7.71966Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgReferenceObject);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reference-object.5f5c895f80466281ababa914024866c0.svg";